import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Styles from './styles.module.css';
import plantImage from '../asset/Image/plant.jpg';

function Contact() {
  const { t } = useTranslation();

  return (
    <div className={`${Styles.appContainer} ${Styles.contactPage}`}>
      <section className={Styles.pageSection}>
        <h1 className={Styles.pageHeader}>{t('Contact Us')}</h1>
        <p className={Styles.pageIntro}>
          {t('Have a question about our dairy products or want fresh delivery at your home? Reach out and our team will respond as soon as possible.')}
        </p>
        <div className={Styles.contactGrid}>
          <div className={Styles.contactCard}>
            <div className={Styles.contactDetails}>
              <div className={Styles.contactSection}>
                <h2 className={Styles.contactHeader}>
                  <FontAwesomeIcon icon={faHome} className={Styles.icon} /> {t('Address')}
                </h2>
                <p className={Styles.contactInfo}>{t('Gat No-66, Bhamboli, Khed, Pune, Maharashtra - 410505')}</p>
              </div>
              <div className={Styles.contactSection}>
                <h2 className={Styles.contactHeader}>
                  <FontAwesomeIcon icon={faPhone} className={Styles.icon} /> {t('Contact us on')}
                </h2>
                <p className={Styles.contactInfo}>{t('+91-7888160160')}</p>
              </div>
              <div className={Styles.contactSection}>
                <h2 className={Styles.contactHeader}>
                  <FontAwesomeIcon icon={faEnvelope} className={Styles.icon} /> {t('Write us on')}
                </h2>
                <p className={Styles.contactInfo}>
                  <a href="mailto:bhamchanramilk@gmail.com" className={Styles.emailLink}>
                    {t('bhamchanramilk@gmail.com')}
                  </a>
                </p>
              </div>
              <div className={Styles.mapContainer}>
                <iframe
                  className={Styles.mapFrame}
                  src="https://www.google.com/maps?q=Gat+No-66+Bhamboli+Khed+Pune+Maharashtra+410505&output=embed"
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
          <div className={Styles.contactCard}>
            <img className={Styles.imageContact} src={plantImage} alt="Dairy Farm" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
